export function getAgreementCards({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getAgreementCards`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
